import React, { useEffect, useState } from "react";
import { products, GANESH_SEASON_ENABLED, DIWALI_SEASON_ENABLED } from "../data/Data";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { addToCart, getCartTotal } from "../redux/CartSlice";
import { logEvent } from "firebase/analytics";
import { analytics } from "../config/firebase";
import "../css/components.css";

export default function Product() {
  const dispatch = useDispatch();
  const [qty, setQty] = useState(1);
  const [imageLoading, setImageLoading] = useState({});
  const [likedProducts, setLikedProducts] = useState({});
  const navigate = useNavigate();

  const handleAddToCart = (e, product) => {
    if(product.out_of_stock){
      return
    }
    e.stopPropagation();
    let totalPrice = qty * product.price;
    const tempProduct = {
      ...product,
      quantity: qty,
      totalPrice,
    };
    dispatch(addToCart(tempProduct));
    dispatch(getCartTotal());
  };

  useEffect(() => {
    logEvent(analytics, "User Entered in the project");
  }, []);

  function wayToItem(item) {
    navigate(`/item/${item.product_name_key}`);
  }

  const handleLikeClick = (e, productId) => {
    e.stopPropagation();
    setLikedProducts(prev => ({
      ...prev,
      [productId]: !prev[productId]
    }));
  };

  const handleImageLoad = (productId) => {
    setImageLoading(prev => ({
      ...prev,
      [productId]: false
    }));
  };

  const handleImageStart = (productId) => {
    setImageLoading(prev => ({
      ...prev,
      [productId]: true
    }));
  };

  const calculateDiscount = (price, mainPrice) => {
    const mrp = Number(mainPrice);
    const now = Number(price);
    if (!mrp || mrp <= now) return null;
    return Math.round(((mrp - now) / mrp) * 100);
  };

  const getProductPriority = (item) => {
    const name = (item.product_name || "").toLowerCase();
    if (name.includes("dhoop") || name.includes("incense")) return 2;
    if (name.includes("jar") || name.includes("cone")) return 1;
    return 0;
  };

  const visibleProducts = products
    .filter(
      (item) =>
        (!item.isGaneshSeasonal || GANESH_SEASON_ENABLED) &&
        (!item.isDiwaliSeasonal || DIWALI_SEASON_ENABLED)
    )
    .sort((a, b) => getProductPriority(b) - getProductPriority(a));

  return (
    <>
      <div className="products-container">
        <div className="container-fluid">
          <div className="row px-xl-5 products-grid">
          {visibleProducts.map((item, index) => {
            const discount = calculateDiscount(item.price, item.mainPrice);
            const isLiked = likedProducts[item.id];
            const isImageLoading = imageLoading[item.id];
            
            return (
              <div className="col-lg-2 col-md-4 col-sm-6 pb-1" key={index}>
                <div
                  className="modern-product-card"
                  style={{ cursor: "pointer" }}
                  onClick={() => wayToItem(item)}
                >
                  {/* Discount Badge */}
                  {discount && (
                    <div className="discount-badge">
                      -{discount}%
                    </div>
                  )}
                  
                  {/* Product Image Container */}
                  <div className="product-image-container">
                    {/* Loading Skeleton */}
                    {isImageLoading && (
                      <div className="skeleton-image"></div>
                    )}
                    
                    <img
                      src={item.product_img}
                      alt={item.product_name}
                      loading="lazy"
                      onLoadStart={() => handleImageStart(item.id)}
                      onLoad={() => handleImageLoad(item.id)}
                      style={{ display: isImageLoading ? 'none' : 'block' }}
                    />
                    
                    {/* Hover Overlay */}
                    <div className="product-overlay"></div>
                    
                    {/* Product Actions */}
                    {!item.out_of_stock && (
                      <div className="product-actions">
                        <button
                          className="action-btn cart-btn min-width60"
                          onClick={(e) => handleAddToCart(e, item)}
                          title="Add to Cart"
                        >
                          <i className="fa fa-shopping-cart"></i>
                        </button>
                        <button
                          className="action-btn wishlist-btn min-width60"
                          onClick={(e) => handleLikeClick(e, item.id)}
                          title="Add to Wishlist"
                        >
                          <svg
                            className={`heart-like ${isLiked ? "liked" : ""}`}
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                          </svg>
                        </button>
                      </div>
                    )}
                    
                    {/* Out of Stock Overlay */}
                    {item.out_of_stock && (
                      <div className="out-of-stock-overlay">
                        <div className="out-of-stock-text">
                          Out of Stock
                        </div>
                      </div>
                    )}
                  </div>
                  
                  {/* Product Info */}
                  <div className="product-info">
                    <Link
                      className="product-title"
                      to={`/item/${item.product_name_key}`}
                      style={{ textDecoration: 'none' }}
                    >
                      {item.product_name}
                    </Link>
                    
                    <div className="product-price-container">
                      <h5 className="current-price">₹{item.price}</h5>
                      {Number(item.mainPrice) > Number(item.price) && (
                        <h6 className="original-price">₹{item.mainPrice}</h6>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
          </div>
        
          {/* Show More Button */}
          <div className="show-more-container">
            <Link className="show-more-btn" to="/shop">
              Show More Products
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
